import { HISTORICAL } from '../lib/historical';

const fmtAbs = (n: number): string => Math.abs(Math.round(n)).toLocaleString('en-NZ');

export function HistoricalStrip() {
  // The footnote is collected from rows that flag a `note` so trustees
  // can see why one of the figures is partial without it being inline
  // and noisy.
  const footnotes = HISTORICAL.filter((h) => h.note);

  return (
    <section className="mb-4 no-print">
      <div className="border-b border-edge pb-2 mb-4">
        <div className="flex items-baseline justify-between flex-wrap gap-2">
          <h2 className="text-[18px] font-semibold text-ccaanz-gold tracking-[0.005em]">
            Historical Context
          </h2>
          <div className="text-xs text-ccaanz-grey">
            Surplus / (Deficit) from prior financial years
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {HISTORICAL.map((h) => {
          const positive = h.surplus >= 0;
          return (
            <div key={h.year} className="p-4 bg-paper border border-edge rounded-control">
              <div className="text-[10px] uppercase tracking-[0.08em] text-ccaanz-grey font-medium">
                {h.year}
                {h.partial && <span className="text-ccaanz-gold"> *</span>}
              </div>
              <div
                className={`text-[22px] font-semibold mt-1 num ${positive ? 'text-ccaanz-blue' : 'text-ccaanz-black'}`}
              >
                {positive ? fmtAbs(h.surplus) : `(${fmtAbs(h.surplus)})`}
              </div>
            </div>
          );
        })}
      </div>

      {footnotes.length > 0 && (
        <div className="mt-3 space-y-1">
          {footnotes.map((h) => (
            <div key={h.year} className="text-[11px] italic text-ccaanz-grey">
              <span className="text-ccaanz-gold not-italic">*</span> {h.year}: {h.note}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
